import React, {Component} from 'react';
import Moment from 'moment';
import 'moment/locale/fr';
import axios from "axios";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'

import AuthService from "../../AuthService";
import loader from "../../img/loader.gif";
import authService from "../../AuthService";

class Extras extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mode : 1,
            selectedVille: (this.props.match.params.villeId === undefined  ? 0 : this.props.match.params.villeId),
            selectedOptions: [],
            croisieresList: [],
            calendarType: '/getCalendar',
            displayDetails: false,
            result: null,
            data: '',
            croisiereOptionsList: [],
            assoCroisiereOptionsList: [],
            villeList: [],
            formData: {
                date: new Date()
            },
            isOpen: false,
            anchorId: null
        }
        this.previousWeek = this.previousWeek.bind(this);
        this.nextWeek = this.nextWeek.bind(this);
    }

    async componentDidMount() {
        this.setState({isLoading: true});
        await this.loadData();
        if (!!this.props.match.params.croisiereId) {
            await this.selectCroisiere(this.props.match.params.croisiereId);
        }
    }

    async loadData(newDate) {
        let date = !!newDate ? newDate : (!!this.props.match.params.croisiereDate && !!this.state.formData.date !== new Date()) ? Moment(this.props.match.params.croisiereDate, "DDMMYYYY") : this.state.formData.date;

        let startDate;
        if (this.state.mode === 1) {
            startDate = Moment(date).startOf('week');
        } else if (this.state.mode === 2) {
            startDate = date;
        }

        let endDate;
        if (this.state.mode === 1) {
            endDate = Moment(startDate).add(7, 'days');
        } else if (this.state.mode === 2) {
            endDate = startDate;
        }

        let allDays;
        if (this.state.mode === 1) {
            allDays = [
                startDate,
                Moment(startDate).add(1, 'days'),
                Moment(startDate).add(2, 'days'),
                Moment(startDate).add(3, 'days'),
                Moment(startDate).add(4, 'days'),
                Moment(startDate).add(5, 'days'),
                Moment(startDate).add(6, 'days')];
        } else if (this.state.mode === 2) {
            allDays = [startDate];
        }

        await axios.post(AuthService.getUrl('/getVillesByUser'), {userId: authService.decodeToken(authService.getToken()).id}, AuthService.getAuthHeader()).then(res => {
            if(!res.data.data['list'] || res.data.data['list'].length == 0){
                authService.getUserById().then(res => {
                    const isCapitaine = res.data.data.capitaine === "oui";
                    if(isCapitaine){
                        alert("Vous n'êtes associé à aucune ville, veuillez contacter l'administration !");
                        authService.disconnect();
                        this.props.history.push('/admin');
                    } else {
                        alert("Vous n'êtes associé à aucune ville, veuillez contacter l'administration !");
                        this.props.history.push('/admin/utilisateurs');
                    }
                });
            }
            this.setState({
                villeList: res.data.data['list']
            });
        });

        await axios.post(AuthService.getUrl(this.state.calendarType), {
            villeId: this.state.selectedVille,
            date: Moment(date).format("DD/MM/YYYY"),
            croisiereId: this.state.selectedCroisireId,
            userId: authService.decodeToken(authService.getToken()).id
        }, AuthService.getAuthHeader()).then(res => {
            this.setState({
                result: res.return,
                data: res.data.data
            });
            this.setState({isLoading: false});
        });

        this.setState(state => {
            const formData = state.formData;
            formData.date = date;
            formData.startDate = startDate;
            formData.endDate = endDate;
            formData.dates = allDays;
            return {formData: formData};
        });

        await axios.post(AuthService.getUrl('/getExtrasByVille'), {
            villeId: this.state.selectedVille,
            date: Moment(date).format("DD/MM/YYYY")
        }, AuthService.getAuthHeader()).then(async res => {

            this.setState({
                croisiereOptionsList: res.data.data.croisiereOptions,
                assoCroisiereOptionsList: res.data.data.assoCroisiereOptions
            });

            this.state.data.croisieres.map(croisiere => {
                const assoCroisiereOptions = this.state.assoCroisiereOptionsList.filter(assoCroisiereOption => assoCroisiereOption.croisiere.id  === croisiere.id);
                croisiere.assoCroisiereOptions = assoCroisiereOptions;
            });

            if (!!newDate) {
                const newCroisieresList = [];
                const newCroisieresId = [];
                this.state.data.croisieres.map( croisiere => {
                    croisiere.assoCroisiereOptions.map(assoCroisiereOption => {
                        if (this.state.selectedOptions.includes(assoCroisiereOption.croisiereOption.id) && !newCroisieresId.includes(croisiere.id)) {
                            newCroisieresList.push(croisiere);
                            newCroisieresId.push(croisiere.id);
                        }
                    });
                });

                this.setState({
                    croisieresList: newCroisieresList
                });
            }
        });
    }

    previousWeek() {
        this.setState({isLoading: true});
        this.setState({formError: null});
        this.setState({displayDetails: false});
        if (this.state.mode === 1) {
            this.loadData(Moment(this.state.formData.date).subtract(7, 'days'));
        } else if (this.state.mode === 2) {
            this.loadData(Moment(this.state.formData.date).subtract(1, 'days'));
        }
    }

    nextWeek() {
        this.setState({isLoading: true});
        this.setState({formError: null});
        this.setState({displayDetails: false});
        if (this.state.mode === 1) {
            this.loadData(Moment(this.state.formData.date).add(7, 'days'));
        } else if (this.state.mode === 2) {
            this.loadData(Moment(this.state.formData.date).add(1, 'days'));
        }
    }

    async selectCroisiere(croisiereId) {
        this.setState({formError: null});
        this.setState({selectedCroisireId: croisiereId});
        this.setState({displayDetails: true});

        await axios.post(AuthService.getUrl("/getCollisionByCroisiere"), {croisiereId: croisiereId}, AuthService.getAuthHeader()).then(res => this.setState({
            formError: res.data.data.message
        }));
        this.setState({currentCroisiereTooltip: this.state.croisieresList?.filter((e) => e.id === croisiereId)[0]});
    }

    async selectCroisiereMouseOver(croisiereId) {
        await axios.post(AuthService.getUrl("/getCollisionByCroisiere"), {croisiereId: croisiereId}, AuthService.getAuthHeader()).then(res => this.setState({
            formError: res.data.data.message
        }));
        this.setState({currentCroisiereTooltip: this.state.croisieresList?.filter((e) => e.id === croisiereId)[0]});
        /*this.setState({formError: null});
        this.setState({displayForm: false});
*/
        /*this.setState({selectedCroisireId: croisiereId});*/
        /*axios.post(AuthService.getUrl("/getCollisionByCroisiere"), {croisiereId: croisiereId}, AuthService.getAuthHeader()).then(res => this.setState({
            formError: res.data.data.message
        }));
        this.setState( {currentCroisiereTooltip: this.state.croisieresList?.filter((e) => e.id === croisiereId)[0]});
        this.setState({displayDetails: true});
        ReactTooltip.rebuild();*/
    }

    async villeChange(e) {
        e.preventDefault();
        this.setState({isLoading: true, selectedCroisireId: undefined, selectedOptions : [], croisieresList: []});
        let value = e.target.value;
        await this.setState({
            selectedVille: value
        });
        this.loadData();
        if (!!this.props.match.params.croisiereId) {
            this.selectCroisiere(this.props.match.params.croisiereId);
        }
    }

    getColumnStyle(index) {
        return {
            left: "calc(" + index + " * 14.28%)"
        };
    }

    getColumnClass() {
        if (this.state.mode === 1) {
            return "calendar-column";
        } else if (this.state.mode === 2) {
            return "calendar-column-daily";
        }
    }

    getCroisiereClass(croisiereId) {
        if (croisiereId == this.state.selectedCroisireId) {
            return "croisiereseleted";
        } else {
            return "";
        }
    }

    getItemStyle(croisiere) {
        let style = {};
        let date = null;
        let bateauId = null;
        let duree = null;
        let background = null;
        let delaiBefore = 0;
        let delaiAfter = 0;

        if (!!croisiere) {
            if (this.state.displayForm && !!this.state.selectedCroisireId && this.state.selectedCroisireId === croisiere.id) {
                date = new Date(this.state.formData.croisiereDate);
                bateauId = this.state.formData.croisiereBateauId;
                duree = this.state.formData.croisiereTypeDuree;
                //background = "repeating-linear-gradient(45deg, " + croisiere.bateau.planningColor + ", " + croisiere.bateau.planningColor + " 10px, #000000 10px, #000000 20px)"
                background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
            } else {
                date = new Date(Moment(croisiere.date, "DD/MM/YYYY HH:mm").format());
                bateauId = croisiere.bateau.id;
                duree = croisiere.croisiereType.duree;
                background = croisiere.bateau.planningColor;
                delaiBefore = croisiere.delaiBefore;
                delaiAfter = croisiere.delaiAfter;
            }
        } else {
            date = new Date(this.state.formData.croisiereDate);
            bateauId = this.state.formData.croisiereBateauId;
            duree = this.state.formData.croisiereTypeDuree;
            background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
        }

        let hour = date.getHours();
        let min = date.getMinutes();

        let left = "90%";
        /*if (!!bateauId) {
            if (bateauId > 10)
                left = "calc(" + (bateauId / 10 - 1) + " * 10%)";
            else
                left = "calc(" + (bateauId - 1) + " * 10%)";
        }*/
        let pixelTop = hour;
        if (min === 30) {
            pixelTop += 0.5;
        } else if (min === 15) {
            pixelTop += 0.25;
        } else if (min === 45) {
            pixelTop += 0.75;
        } else {
            pixelTop += 0;
        }

        let pixelDelai = 0;
        if (delaiBefore === 30) {
            pixelDelai += 0.5;
        } else if (pixelDelai === 15) {
            pixelDelai += 0.25;
        } else if (pixelDelai === 45) {
            pixelDelai += 0.75;
        } else {
            pixelDelai += 0;
        }

        if (delaiBefore > 0) {
            delaiBefore -= 5;
        }
        style = {
            width: "100%",
            height: 49 * duree + "px",
            background: background,
            top: (pixelTop * 47) - (pixelTop * 47) + delaiBefore + "px"
            /*left: left,
            top: pixelTop * 50 + "px",
            width: "9%",
            height: 50 * duree + "px",
            //lineHeight: 50 * duree + "px",
            background: background*/
        };

        return style;
    }

    getBorderStyle(croisiere) {
        let style = {};
        let date = null;
        let bateauId = null;
        let duree = null;
        let background = null;
        let delaiBefore = 0;
        let delaiAfter = 0;

        if (!!croisiere) {
            if (this.state.displayForm && !!this.state.selectedCroisireId && this.state.selectedCroisireId === croisiere.id) {
                date = new Date(this.state.formData.croisiereDate);
                bateauId = this.state.formData.croisiereBateauId;
                duree = this.state.formData.croisiereTypeDuree;
                //background = "repeating-linear-gradient(45deg, " + croisiere.bateau.planningColor + ", " + croisiere.bateau.planningColor + " 10px, #000000 10px, #000000 20px)"
                background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
                delaiBefore = croisiere.delaiBefore;
                delaiAfter = croisiere.delaiAfter;
            } else {
                date = new Date(Moment(croisiere.date, "DD/MM/YYYY HH:mm").subtract(croisiere.delaiBefore, 'm').format());
                bateauId = croisiere.bateau.id;
                duree = croisiere.croisiereType.duree;
                background = croisiere.bateau.planningColor;
                delaiBefore = croisiere.delaiBefore;
                delaiAfter = croisiere.delaiAfter;
            }
        } else {
            date = new Date(this.state.formData.croisiereDate);
            bateauId = this.state.formData.croisiereBateauId;
            duree = this.state.formData.croisiereTypeDuree;
            background = "repeating-linear-gradient(45deg, #B5B5B5, #B5B5B5 10px, #000000 10px, #000000 20px)";
        }

        let hour = date.getHours();
        let min = date.getMinutes();
        let height = (47 * duree + duree * 2 - 1) + delaiBefore + delaiAfter;

        let left = "90%";
        if (!!bateauId) {
            /* Paris */
            if (bateauId == 5) {
                left = "calc(0%)";
            } else if (bateauId == 2) {
                left = "calc(10%)";
            } else if (bateauId == 3) {
                left = "calc(20%)";
            } else if (bateauId == 8) {
                left = "calc(30%)";
            } else if (bateauId == 42) {
                left = "calc(40%)";
            } else if (bateauId == 4) {
                left = "calc(50%)";
            } else if (bateauId == 6) {
                left = "calc(60%)";
            } else if (bateauId == 7) {
                left = "calc(70%)";
            } else if (bateauId == 43) {
                left = "calc(80%)";
            }
            /* Nogent */
            else if (bateauId == 1) {
                left = "calc(0%)";
            } else if (bateauId == 33) {
                left = "calc(10%)";
            } else if (bateauId == 34) {
                left = "calc(20%)";
            } else if (bateauId == 35) {
                left = "calc(30%)";
            }
        }
        let pixelTop = hour;
        if (min === 30) {
            pixelTop += 0.5;
        } else if (min === 15) {
            pixelTop += 0.25;
        } else if (min === 45) {
            pixelTop += 0.75;
        } else {
            pixelTop += 0;
        }

        if (delaiBefore > 0) {
            height -= 5;
        }
        if (delaiAfter > 0) {
            height -= 5;
        }

        style = {
            left: left,
            top: pixelTop * 50 + "px",
            width: "9%",
            height: height + "px",
            border: '3px solid rgba(0, 0, 0, 1)'
        };

        return style;
    }

    checkOption(e) {
        const value = parseInt(e.target.value);
        const isChecked = e.target.checked;
        let selectedOptions = this.state.selectedOptions;

        if (isChecked) {
            selectedOptions.push(value);
            this.setState({
                selectedOptions: selectedOptions
            });
        } else {
            const index = selectedOptions.indexOf(value, 0);
            if (index > -1) {
                selectedOptions.splice(index, 1);
                this.setState({
                    selectedOptions: selectedOptions
                });
            }
        }

        const newCroisieresList = [];
        const newCroisieresId = [];
        this.state.data.croisieres.map( croisiere => {
            croisiere.assoCroisiereOptions.map(assoCroisiereOption => {
                if (this.state.selectedOptions.includes(assoCroisiereOption.croisiereOption.id) && !newCroisieresId.includes(croisiere.id)) {
                    newCroisieresList.push(croisiere);
                    newCroisieresId.push(croisiere.id);
                }
            });
        });

        this.setState({
            croisieresList: newCroisieresList
        });
    }

    selectCroisiereUi(croisiere) {
        if (!!croisiere) {
            var elements = document.getElementsByClassName("calendar-item");
            var count = elements.length;
            for (var i=0; i<count; i++) {
                elements[i].classList.remove("croisiereseleted");
            }
            document.getElementById('calendarDiv' + croisiere.id).classList.add("croisiereseleted");
        }
    }

    changeMode = (newmode) => {
        if (this.state.mode === 1) {
            this.setState({mode: 2}, this.loadData)
        } else {
            this.setState({mode: 1}, this.loadData)
        }
    }

    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            return (
                <div className="box">
                    <div className="boxTitle">Calendrier</div>
                    <div className="boxContent">
                        <div className="calendarSelector">
                            {<select className="value" type="text" name="villes" value={this.state.selectedVille}
                                     onChange={e => this.villeChange(e)}>
                                <option key={0} value={0}>---</option>
                                {this.state.villeList.map(ville => (
                                    <option key={ville.id} value={ville.id}>{ville.nom}</option>
                                ))}
                            </select>}
                            {this.state.mode === 1 &&
                            <button className="coreBlockItem-typeSubmitSearch" style={{"width" : "150px"}} onClick={this.changeMode}>Vue journalière</button>
                            }
                            {this.state.mode === 2 &&
                            <button className="coreBlockItem-typeSubmitSearch" style={{"width" : "150px"}} onClick={this.changeMode}>Vue hebdomadaire</button>
                            }
                            <div className="calendarPrevious" onClick={e => this.previousWeek(e)}></div>
                            <div className="calendarCurrent">
                                {this.state.mode === 1 &&
                                <div>
                                    Semaine {Moment(this.state.formData.date).isoWeek()}<br/>
                                    {Moment(this.state.formData.startDate).format("DD/MM/YYYY")} au {Moment(this.state.formData.endDate).format("DD/MM/YYYY")}
                                </div>
                                }
                                {this.state.mode === 2 &&
                                <div>
                                    {Moment(this.state.formData.startDate).format("DD MMMM YYYY")}
                                </div>
                                }
                            </div>
                            <div className="calendarNext" onClick={e => this.nextWeek(e)}></div>
                        </div>

                        <div id="calendar">
                            {this.state.displayDetails &&
                                <div id="calendar-details" className="box">
                                    {this.state.croisieresList.map(croisiere => (
                                        <React.Fragment>
                                            {croisiere.id == this.state.selectedCroisireId &&
                                                <React.Fragment>
                                                    <div
                                                        className={"boxTitle croisiereStatut-" + croisiere.refCroisiereStatut.id}>CROISIERE
                                                        #{croisiere.id}</div>
                                                    <div className="boxContent">
                                                        <div id="infoIcon-1"
                                                             className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")}</div>
                                                        <br/>
                                                        <div id="infoIcon-2"
                                                             className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("HH:mm")}</div>
                                                        <br/>
                                                        <div id="infoIcon-3"
                                                             className="infoIcon">{!!croisiere.bateau ? croisiere.bateau.nom : ""}</div>
                                                        <br/>
                                                        <div id="infoIcon-4"
                                                             className="infoIcon">{!!croisiere.utilisateur ? croisiere.utilisateur.fullName : ""}</div>
                                                        <br/><br/>
                                                        {this.state.formError &&
                                                            <ul className="errorMessage alignCenter">
                                                                <li><span>{this.state.formError}</span></li>
                                                            </ul>
                                                        }
                                                        <div className="alignCenter">
                                                            <button type="button" className="validButton"
                                                                    style={{width: "100%", marginBottom: "10px"}}
                                                                    onClick={e => document.location = "/admin/croisiere/" + croisiere.id}>Voir
                                                                détails
                                                            </button>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            }
                                        </React.Fragment>
                                    ))}
                                </div>
                            }

                            <div id="calendar-box">
                                {this.state.isLoading &&
                                    <img src={loader} alt="loading"
                                         style={{"display": "block", "margin": "50px auto"}}/>
                                }
                                {this.state.formData?.dates?.map((date, index) => (
                                    <div className={this.getColumnClass()} style={this.getColumnStyle(index)}>
                                        <div className="calendar-column-title"
                                             style={JSON.parse(!(Moment(date).format("DD/MM/YYYY") === Moment(new Date()).format("DD/MM/YYYY")) ? "{}" : "{\"color\": \"#FF0000\"}")}>
                                            {Moment(date).format("dddd")}
                                            <br/>
                                            {Moment(date).format("DD/MM")}
                                        </div>
                                        {this.state.croisieresList.map(croisiere => (
                                            <React.Fragment>
                                                <Tooltip id={'calendarTooltip' + croisiere.id} anchorSelect={'.calendarTooltip' + croisiere.id} key={croisiere.id} effect={"solid"} openOnClick clickable>
                                                    <div className="calendar-tooltip">
                                                        <div
                                                            className={"boxTitle croisiereStatut-" + croisiere.refCroisiereStatut.id}>{croisiere.clientNom}</div>
                                                        <div className="boxContent">
                                                            <div id="infoIcon-1"
                                                                 className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")}</div>
                                                            <br/>
                                                            <div id="infoIcon-2"
                                                                 className="infoIcon">{Moment(croisiere.date, "DD/MM/YYYY HH:mm").format("HH:mm")}</div>
                                                            <br/>
                                                            {croisiere.assoCroisiereOptions.map(assoCroisiereOption => (
                                                                <React.Fragment>
                                                                    <div id={"infoIcon-" + assoCroisiereOption.id}
                                                                         className="infoIcon">{'* ' + assoCroisiereOption.croisiereOption.label} ({assoCroisiereOption.nbCharged + assoCroisiereOption.nbFree})</div>
                                                                    <br/>
                                                                </React.Fragment>
                                                            ))}
                                                            <br/><br/>

                                                            {this.state.formError &&
                                                                <ul className="errorMessage alignCenter">
                                                                    <li><span>{this.state.formError}</span></li>
                                                                </ul>
                                                            }
                                                            <div className="alignCenter">
                                                                <button type="button" className="validButton" style={{width: "100%", marginBottom: "10px"}}
                                                                        onClick={e => document.location = "/admin/croisiere/" + croisiere.id}>Voir
                                                                    détails
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tooltip>

                                                {croisiere.bateau !== null && croisiere.date !== null && (!this.state.selectedCroisireId || this.state.selectedCroisireId !== croisiere.id || !this.state.formData.croisiereDate) && Moment(croisiere.date, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY") === Moment(date).format("DD/MM/YYYY") &&
                                                    <div style={this.getBorderStyle(croisiere)}
                                                         className={"calendar-item"  + ' ' + this.getCroisiereClass(croisiere.id)} id={'calendarDiv' + croisiere.id}>
                                                        <a key={croisiere.id} onClick={e => this.selectCroisiereUi(croisiere)}
                                                             className={'calendarTooltip' + croisiere.id + ' ' + 'calendar-item croisiereStatut-' + croisiere.refCroisiereStatut.id}
                                                             style={this.getItemStyle(croisiere)}
                                                             id={'calendarTooltip' + croisiere.id}>
                                                            {!!croisiere.bateau ? croisiere.bateau.nom.substring(0, 3) : ""}
                                                        </a>
                                                    </div>
                                                }
                                                {croisiere.bateau !== null && croisiere.date !== null && !!this.state.selectedCroisireId && this.state.selectedCroisireId === croisiere.id && !!this.state.formData.croisiereDate && Moment(this.state.formData.croisiereDate).format("DD/MM/YYYY") === Moment(date).format("DD/MM/YYYY") &&
                                                    <div style={this.getBorderStyle(croisiere)}
                                                         className={"calendar-item"  + ' ' + this.getCroisiereClass(croisiere.id)} id={'calendarDiv' + croisiere.id}>
                                                        <a key={croisiere.id} onClick={e => this.selectCroisiereUi(croisiere)}
                                                           className={'calendarTooltip' + croisiere.id + ' ' + 'calendar-item croisiereStatut-' + croisiere.refCroisiereStatut.id}
                                                             style={this.getItemStyle(croisiere)}
                                                             id={'calendarTooltip' + croisiere.id}>
                                                            {!!croisiere.bateau ? croisiere.bateau.nom.substring(0, 3) : ""}
                                                        </a>
                                                    </div>
                                                }


                                            </React.Fragment>
                                        ))}
                                    </div>
                                ))}

                                <div className="calendar-time" style={{top: "-15px"}}>00h00</div>
                                <div className="calendar-time-right" style={{top: "-15px"}}>00h00</div>
                                <div className="calendar-time" style={{top: "35px"}}>01h00</div>
                                <div className="calendar-time-right" style={{top: "35px"}}>01h00</div>
                                <div className="calendar-time" style={{top: "85px"}}>02h00</div>
                                <div className="calendar-time-right" style={{top: "85px"}}>02h00</div>
                                <div className="calendar-time" style={{top: "135px"}}>03h00</div>
                                <div className="calendar-time-right" style={{top: "135px"}}>03h00</div>
                                <div className="calendar-time" style={{top: "185px"}}>04h00</div>
                                <div className="calendar-time-right" style={{top: "185px"}}>04h00</div>
                                <div className="calendar-time" style={{top: "235px"}}>05h00</div>
                                <div className="calendar-time-right" style={{top: "235px"}}>05h00</div>
                                <div className="calendar-time" style={{top: "285px"}}>06h00</div>
                                <div className="calendar-time-right" style={{top: "285px"}}>06h00</div>
                                <div className="calendar-time" style={{top: "335px"}}>07h00</div>
                                <div className="calendar-time-right" style={{top: "335px"}}>07h00</div>
                                <div className="calendar-time" style={{top: "385px"}}>08h00</div>
                                <div className="calendar-time-right" style={{top: "385px"}}>08h00</div>
                                <div className="calendar-time" style={{top: "435px"}}>09h00</div>
                                <div className="calendar-time-right" style={{top: "435px"}}>09h00</div>
                                <div className="calendar-time" style={{top: "485px"}}>10h00</div>
                                <div className="calendar-time-right" style={{top: "485px"}}>10h00</div>
                                <div className="calendar-time" style={{top: "535px"}}>11h00</div>
                                <div className="calendar-time-right" style={{top: "535px"}}>11h00</div>
                                <div className="calendar-time" style={{top: "585px"}}>12h00</div>
                                <div className="calendar-time-right" style={{top: "585px"}}>12h00</div>
                                <div className="calendar-time" style={{top: "635px"}}>13h00</div>
                                <div className="calendar-time-right" style={{top: "635px"}}>13h00</div>
                                <div className="calendar-time" style={{top: "685px"}}>14h00</div>
                                <div className="calendar-time-right" style={{top: "685px"}}>14h00</div>
                                <div className="calendar-time" style={{top: "735px"}}>15h00</div>
                                <div className="calendar-time-right" style={{top: "735px"}}>15h00</div>
                                <div className="calendar-time" style={{top: "785px"}}>16h00</div>
                                <div className="calendar-time-right" style={{top: "785px"}}>16h00</div>
                                <div className="calendar-time" style={{top: "835px"}}>17h00</div>
                                <div className="calendar-time-right" style={{top: "835px"}}>17h00</div>
                                <div className="calendar-time" style={{top: "885px"}}>18h00</div>
                                <div className="calendar-time-right" style={{top: "885px"}}>18h00</div>
                                <div className="calendar-time" style={{top: "935px"}}>19h00</div>
                                <div className="calendar-time-right" style={{top: "935px"}}>19h00</div>
                                <div className="calendar-time" style={{top: "985px"}}>20h00</div>
                                <div className="calendar-time-right" style={{top: "985px"}}>20h00</div>
                                <div className="calendar-time" style={{top: "1035px"}}>21h00</div>
                                <div className="calendar-time-right" style={{top: "1035px"}}>21h00</div>
                                <div className="calendar-time" style={{top: "1085px"}}>22h00</div>
                                <div className="calendar-time-right" style={{top: "1085px"}}>22h00</div>
                                <div className="calendar-time" style={{top: "1135px"}}>23h00</div>
                                <div className="calendar-time-right" style={{top: "1135px"}}>23h00</div>
                                <div className="calendar-time" style={{top: "1185px"}}>24h00</div>
                                <div className="calendar-time-right" style={{top: "1185px"}}>24h00</div>
                            </div>
                        </div>
                        <div id="options-box">
                            {this.state.croisiereOptionsList.map(options => (
                                <div className="option">
                                    <input type="checkbox" checked={this.state.selectedOptions.includes(options.id)}
                                           id={options.id} value={options.id} onChange={e => this.checkOption(e)}/>
                                    <label htmlFor="scales">{options.label}</label>
                                </div>
                            ))
                            }
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default Extras;
